import { Switch, Tab, Tabs, Typography } from '@material-ui/core'
import { newProjectActions } from 'features/BillOfMaterials/store/newProjectReducer'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'store/configureStore'
import { TabPanel } from '../../../../components/Layout/TabPanelProps'
import { BoMItemFilterCount } from './BoMItemFilterCounter/BoMItemFilterCounter'
import './FiltersContainer.scss'
import { IssuesFilterContainer } from './IssuesFilter/IssuesFilterContainer'
import { MaterialKeywordFilter } from './MaterialKeywordsFilter/MaterialKeywordFilter'
import { useEnabledBoMFilters } from './useEnabledBoMFilters'
import { WorkingStepsFilter } from './WorkingStepsFilter/WorkingStepsFilter'

// const getStyles = (enabled, theme: Theme) => ({
//   backgroundColor: enabled ? theme.palette.success.light : undefined,
//   color: enabled
//     ? theme.palette.getContrastText(theme.palette.success.light)
//     : undefined,
// })

export const FiltersContainer = (props: { openTab?: number }) => {
  const [currentTab, setCurrentTab] = useState(props.openTab || 0)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const {
    workingStepsFilterEnabled,
    materialFilterEnabled,
    issueFilterEnabled,
    issuesFilterCount,
  } = useEnabledBoMFilters()

  useEffect(() => {
    setCurrentTab(props.openTab || 0)
  }, [props.openTab])

  useEffect(() => {
    if (issuesFilterCount === 0) {
      setCurrentTab(0)
    }
  }, [issuesFilterCount])

  // const workingStepTabStyles = useMemo(() => {
  //   return getStyles(workingStepsFilterEnabled, theme)
  // }, [workingStepsFilterEnabled, theme])

  // const materialTabClasses = useMemo(
  //   () => getStyles(materialFilterEnabled, theme),
  //   [materialFilterEnabled, theme]
  // )

  return (
    <div className="filters-container">
      <div className="filter-header">
        <BoMItemFilterCount
          workingStepFilterEnabled={workingStepsFilterEnabled}
          materialFilterEnabled={materialFilterEnabled}
          issuesFilterEnabled={issueFilterEnabled}
        />
      </div>
      <Tabs
        value={currentTab}
        indicatorColor="primary"
        variant="fullWidth"
        scrollButtons="auto"
        onChange={(e, newValue) => setCurrentTab(newValue)}
      >
        <Tab
          // style={workingStepTabStyles}
          label={
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Switch
                checked={workingStepsFilterEnabled}
                color="primary"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  dispatch(
                    newProjectActions.toggleActiveFilter({
                      filterType: 'WorkingStepFilter',
                    })
                  )
                }}
                size="small"
              />
              <Typography>
                {t(`common:working-steps`, 'working steps')}
              </Typography>
            </div>
          }
        />
        <Tab
          // style={materialTabClasses}
          label={
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Switch
                checked={materialFilterEnabled}
                color="primary"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  dispatch(
                    newProjectActions.toggleActiveFilter({
                      filterType: 'MaterialKeywordsFilter',
                    })
                  )
                }}
                size="small"
              />
              <Typography>
                {t(`common:material-keywords`, 'material keywords')}
              </Typography>
            </div>
          }
        />
        {issuesFilterCount > 0 && (
          <Tab
            label={
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Switch
                  checked={issueFilterEnabled}
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    dispatch(
                      newProjectActions.toggleActiveFilter({
                        filterType: 'IssuesFilter',
                      })
                    )
                  }}
                  size="small"
                />
                <div style={{ position: 'relative', width: '100%' }}>
                  <Typography>{t(`common:issues`, 'issues')}</Typography>
                  <Typography
                    style={{ position: 'absolute', right: 0, top: '4px' }}
                    variant="caption"
                    color="secondary"
                  >{`${issuesFilterCount}`}</Typography>
                </div>
              </div>
            }
          />
        )}

        {/* <Tab label={t('common:issues', 'issues')} /> */}
      </Tabs>

      <TabPanel value={currentTab} index={0}>
        <WorkingStepsFilter />
      </TabPanel>
      <TabPanel value={currentTab} index={1}>
        <MaterialKeywordFilter />
      </TabPanel>
      <TabPanel value={currentTab} index={2}>
        <IssuesFilterContainer showTitle={false} />
      </TabPanel>
    </div>
  )
}

export default React.memo(FiltersContainer)
